<script setup lang="ts">
import { PhFolder } from '@phosphor-icons/vue';
import { onMounted, useTemplateRef } from 'vue';
import { useDragPreviewRef } from '../../logic/drag-drop/useDragPreviewRef';
import { useSelectionBreakdown } from '../../logic/selection/useSelectionBreakdown';
import { DEFAULT_FILE_ICON } from '../../views/file-explorer-view/sub-components/render-modes/_shared/file-object/sub-components/file-item/get-file-icon';

const breakdown = useSelectionBreakdown();
const { previewEl } = useDragPreviewRef();
const rootRef = useTemplateRef<HTMLElement>('root');
onMounted(() => {
  previewEl.value = rootRef.value;
});
</script>

<template>
  <div ref="root" class="drag-preview">
    <span class="drag-preview-icons">
      <span class="drag-preview-total-count">{{ breakdown.total }}</span>
      <span v-if="breakdown.directoryCount > 0" class="drag-preview-badge">
        <PhFolder :size="32" weight="fill" color="var(--primary-color)" />
        <span class="drag-preview-count">{{ breakdown.directoryCount }}</span>
      </span>
      <span v-if="breakdown.fileCount > 0" class="drag-preview-badge">
        <component
          :is="DEFAULT_FILE_ICON.icon"
          :size="32"
          weight="fill"
          :color="DEFAULT_FILE_ICON.color"
        />
        <span class="drag-preview-count">{{ breakdown.fileCount }}</span>
      </span>
    </span>
  </div>
</template>

<style scoped>
.drag-preview {
  position: fixed;
  top: -9999px;
  left: -9999px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1.25rem 0.5rem 0.75rem;
  border-radius: 999px;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  pointer-events: none;
  white-space: nowrap;
}

.drag-preview-icons {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.drag-preview-total-count {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 2rem;
  height: 2rem;
  padding: 0 0.75rem;
  border-radius: 999px;
  background: #f3f4f6;
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 2rem;
  color: #111827;
}

.drag-preview-badge {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.drag-preview-count {
  position: absolute;
  bottom: -0.25rem;
  right: -0.375rem;
  min-width: 1.125rem;
  height: 1.125rem;
  padding: 0 0.25rem;
  border-radius: 999px;
  background: white;
  box-shadow:
    0 0 0 1px rgba(0, 0, 0, 0.08),
    0 1px 2px rgba(0, 0, 0, 0.15);
  font-size: 0.625rem;
  font-weight: 700;
  line-height: 1.125rem;
  text-align: center;
  color: #374151;
}
</style>
